import React, {useCallback, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import styled from 'styled-components';
import ReactModalContent from '../Shared/Modal/ReactModalContent';
import ReactModalFooter from '../Shared/Modal/ReactModalFooter';
import {ANALYTICS_IDS} from "../../utils/analyticsTrackingConstants";
import {BeaconModal} from "../Shared/Modal/BeaconModal";
import ReactModalHeader from "../Shared/Modal/ReactModalHeader";
import {getDomain} from "../../utils/api";

const StyledNoticeText = styled.div`
  margin-top: 24px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.02px;
`;

const StyledContent = styled.div`
`;

const StyledLink =  styled.a`
  text-decoration: underline;
  color: #086ea1;
  cursor: pointer;
`;

export const SignUpAllSetModal = ({modalName,handleCloseModal,dispatchOverlayLoad}) => {
    const dispatch = useDispatch();

    const preferencesSubscriptionPage = useCallback(() => {
        handleCloseModal();
    },[dispatch]);

    useEffect(() => {
        const overlay = "All Set Modal";
        dispatchOverlayLoad(overlay);
    }, []);

    const goToNewPage = () => {
        document.location.href = getDomain() + "/personal-investing/help/policies-and-security/text-message-agreement.html";
    }
    const getFooter = () => {
        return   <ReactModalFooter
            tertiaryButtonText={"Close"}
            primaryButtonText={"View Preferences & Subscriptions"}
            handleOnClick={preferencesSubscriptionPage}
            handleCancelClick={handleCloseModal}
            primaryButtonId = {ANALYTICS_IDS.SignUpAllSetModalPreferencesSubscriptionsBtn}
            tertiaryButtonId={ANALYTICS_IDS.SignUpAllSetModalCloseBtn}
            isAllSetModal={true}
        />
    };


    return (
        <React.Fragment>

            <BeaconModal id={modalName}
                         footer={getFooter()}>

                <ReactModalContent>
                    <ReactModalHeader modalTitle="All set!" showCheckBadgeIcon={true}/>
                    <StyledContent>You are signed up to receive text alerts. You can change your text alert settings on the Preferences & Subscriptions page.</StyledContent>
                    <StyledNoticeText>
                        Message frequency is based on account activity. Message and data rates may apply.
                        Reply HELP to an incoming text alert for assistance or STOP to cancel text alerts.
                        See our&nbsp;<StyledLink target="_blank" href="https://www.troweprice.com/enterprise/legal/us/en/privacy-notices.html">U.S. and Canada Privacy Notice</StyledLink> for more information.
                    </StyledNoticeText>

                </ReactModalContent>
            </BeaconModal>

        </React.Fragment>
    )
}

